import React from "react";
import ImgPF1 from "../../../assets/images/para-voce/img-PF1.png";
import "../global.scss";
import { Link } from "react-router-dom";

export const TabCambioParaViagens = () => {
  return (
    <div className="tab-content">
      <div className="left">
        <div className="content">
          <h1>
            Programe sua viagem ao exterior com a Cobalt e fique tranquilo
          </h1>
          <p>
            Câmbio para viagens internacionais é um assunto importante para se
            planejar antes de embarcar. Aqui estão algumas dicas e informações
            importantes para você:
          </p>
        </div>
        <div className="content">
          <h2 className="title">Planejamento</h2>
          <p>
            <span className="title-span">Pesquise a moeda local: </span>
            Entenda a moeda utilizada no seu destino e a cotação atual em
            relação à sua moeda local. Acompanhe as variações da taxa de câmbio
            para ter uma ideia de quanto precisará.
          </p>
          <p>
            <span className="title-span">Calcule seus gastos: </span>
            Faça um orçamento estimado de quanto pretende gastar na viagem,
            considerando hospedagem, alimentação, transporte, passeios e
            compras. Isso ajudará a definir quanto dinheiro trocar.
          </p>
          <p>
            <span className="title-span">Não deixe para a última hora: </span>
            Comprar moeda estrangeira em aeroportos ou casas de câmbio em
            destinos turísticos costuma ser mais caro devido às taxas e à
            conveniência. Planeje a compra com antecedência para conseguir taxas
            melhores.
          </p>
          <p>
            <span className="title-span">Cuidado com taxas escondidas: </span>
            Mantenha seus dados seguros: Proteja seus cartões e informações
            financeiras durante a viagem.
          </p>
        </div>
      </div>
      <div className="right">
        <img src={ImgPF1} alt="" />
        <div className="vantagens">
          <h2>Vantagens de utilizar a Cobalt</h2>
          <p>
            <span className="title-span">Plataformas de Pagamento Online</span>
            Plataformas como a da Cobalt, que oferecem transferências
            internacionais com taxas, geralmente, mais competitivas que as dos
            bancos tradicionais.
          </p>
          <p>
            <span className="title-span">Transparência</span>
            Aqui na Cobalt, não há taxas escondidas como taxas de saque, taxas
            de conversão e IOF. Todos os custos das transações são informados
            antes do fechamento do câmbio.
          </p>
          <p>
            <span className="title-span">Proteção Cambial</span>O valor recebido
            em moeda local pode variar de acordo com a flutuação da taxa de
            câmbio. Utilizar produtos cambiais, como contratos a termo, pode
            ajudar a mitigar esse risco.
          </p>

          <Link to={"/cadastro"} className="btn-abrir-conta">Abra agora a sua conta</Link>
        </div>
      </div>
    </div>
  );
};
